:host {
  --grid-template-areas: var(
    --stzh-content-grid-template-areas,
    "content content content content"
  );

  @include mq($from: medium) {
    --grid-template-areas: var(
      --stzh-content-grid-template-areas,
      "content content content content content content content content"
    );
  }

  @include mq($from: large) {
    --grid-template-areas: var(
      --stzh-content-grid-template-areas,
      "aside-left aside-left content content content content content content content content aside-right aside-right"
    );
  }

  &[variant="shifted"] {
    @include mq($from: large) {
      --grid-template-areas: var(
        --stzh-content-shifted-grid-template-areas,
        var(
          --stzh-content-grid-template-areas,
          "aside-left aside-left content content content content content content content content content aside-right"
        )
      );
    }
  }

  &[variant="full"] {
    @include mq($from: large) {
      --grid-template-areas: var(
        --stzh-content-full-grid-template-areas,
        var(
          --stzh-content-grid-template-areas,
          "content content content content content content content content content content content content"
        )
      );
    }
  }

  ::slotted(*) {
    grid-area: content;
  }

  &:where(:not([prevent-element-layout]:not([prevent-element-layout="false"])))
    ::slotted(*) {
    /* CTA Layout */

    @include mq($from: small) {
      --stzh-cta-small-grid-template-areas: "cta cta cta .";
    }

    @include mq($from: medium) {
      --stzh-cta-grid-template-areas: "cta cta cta cta cta . . .";
      --stzh-cta-small-grid-template-areas: "cta cta cta cta . . . .";
    }

    /* Text / Richtext Layout */

    @include mq($from: small) {
      --stzh-text-display: grid;
      --stzh-text-grid-template-areas: "text text text .";

      --stzh-richtext-display: grid;
      --stzh-richtext-grid-template-areas: "text text text .";
    }

    @include mq($from: medium) {
      --stzh-text-grid-template-areas: "text text text text text text . .";
      --stzh-richtext-grid-template-areas: "text text text text text text . .";
    }

    /* Datalist Layout */

    @include mq($from: small) {
      --stzh-datalist-grid-template-areas: "list list list .";
      // breakout with details element inside datalist-item
      --stzh-datalist-details-content-width: calc(
        ((100% - #{$gridGutterSmall} - 2 * #{$gridGutterSmall}) / 3 * 4) + 3 *
          #{$gridGutterSmall} + #{$gridGutterSmall}
      );
    }

    @include mq($from: medium) {
      --stzh-datalist-grid-template-areas: "list list list list list . . .";
      --stzh-datalist-details-content-width: calc(
        ((100% - #{$gridGutterMedium} - 4 * #{$gridGutterMedium}) / 5 * 8) + 7 *
          #{$gridGutterMedium} + #{$gridGutterMedium}
      );
    }

    @include mq($from: large) {
      --stzh-datalist-details-content-width: calc(
        ((100% - #{$gridGutterLarge} - 4 * #{$gridGutterLarge}) / 5 * 8) + 7 *
          #{$gridGutterLarge} + #{$gridGutterLarge}
      );
    }

    @include mq($from: ultra) {
      --stzh-datalist-details-content-width: calc(
        ((100% - #{$gridGutterUltra} - 4 * #{$gridGutterUltra}) / 5 * 8) + 7 *
          #{$gridGutterUltra} + #{$gridGutterUltra}
      );
    }

    /* Reset layout inside certain components */

    stzh-datalist,
    stzh-eventdata {
      /* Text Layout */

      @include mq($from: small) {
        --stzh-text-display: block;
        --stzh-richtext-display: block;
      }
    }

    stzh-section[variant="highlight"],
    stzh-section[variant="contextbox"],
    stzh-ghettobox,
    stzh-message,
    stzh-toast,
    stzh-tooltip,
    stzh-popover,
    stzh-accordion,
    stzh-timeline,
    stzh-twocolumns,
    stzh-textandimage,
    stzh-datalist stzh-datalist,
    stzh-dialog,
    stzh-overlay {
      /* CTA Layout */

      @include mq($from: small) {
        --stzh-cta-small-grid-template-areas: "cta cta cta cta";
      }

      @include mq($from: medium) {
        --stzh-cta-grid-template-areas: "cta cta cta cta cta cta cta cta";
        --stzh-cta-small-grid-template-areas: "cta cta cta cta cta cta cta cta";
      }

      /* Text Layout */

      @include mq($from: small) {
        --stzh-text-display: block;
        --stzh-richtext-display: block;
      }

      /* Datalist Layout */

      @include mq($from: small) {
        --stzh-datalist-grid-template-areas: "list list list list";
        // breakout with details element inside datalist-item
        --stzh-datalist-details-content-width: calc(
          ((100% - #{$gridGutterSmall} - 2 * #{$gridGutterSmall}) / 4 * 4) + 3 *
            #{$gridGutterSmall} + #{$gridGutterSmall}
        );
      }

      @include mq($from: medium) {
        --stzh-datalist-grid-template-areas: "list list list list list list list list";
        --stzh-datalist-details-content-width: calc(
          ((100% - #{$gridGutterMedium} - 4 * #{$gridGutterMedium}) / 8 * 8) +
            7 * #{$gridGutterMedium} + #{$gridGutterMedium}
        );
      }

      @include mq($from: large) {
        --stzh-datalist-details-content-width: calc(
          ((100% - #{$gridGutterLarge} - 4 * #{$gridGutterLarge}) / 8 * 8) + 7 *
            #{$gridGutterLarge} + #{$gridGutterLarge}
        );
      }

      @include mq($from: ultra) {
        --stzh-datalist-details-content-width: calc(
          ((100% - #{$gridGutterUltra} - 4 * #{$gridGutterUltra}) / 8 * 8) + 7 *
            #{$gridGutterUltra} + #{$gridGutterUltra}
        );
      }
    }
  }
}

.stzh-content {
  // set nested content elements to be fullwidth
  --stzh-content-grid-template-areas: "content content content content content content content content content content content content";
  --stzh-content-shifted-grid-template-areas: "content content content content content content content content content content content content";
  --stzh-content-full-grid-template-areas: "content content content content content content content content content content content content";

  @include grid;
  grid-template-areas: var(--grid-template-areas);
}
